import qs from 'qs';
import request from '../../../../../shared/lib/request';
import { API } from '../../../../../shared/constants';

const getContrattiByCollaboratore = (id) => request(
  {
    url: API.CONTRATTO_COLLABORATORE,
    method: 'GET',
    params: {
      filter: [{
        type: 'eq',
        field: 'collaboratore',
        value: id || null,
      }],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const put = (content) => request(
  {
    url: `${API.CONTRATTO_COLLABORATORE}/${content.id}`,
    method: 'PUT',
    data: content,
  });


const create = (content) => request(
  {
    url: API.CONTRATTO_COLLABORATORE,
    method: 'POST',
    data: content,
  });

const ContrattoService = {
  getContrattiByCollaboratore,
  put,
  create,
};

export default ContrattoService;



// WEBPACK FOOTER //
// ./app/shared/services/api/collaboratore/contratto/index.js